import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CarsService } from './cars.service';
@NgModule({
  imports: [CommonModule],
  providers: [CarsService]
})
export class DataModule { }
